import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}
const _hoisted_7 = { class: "fs-5 fw-bold text-muted mb-2" }
const _hoisted_8 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = { class: "card-body pb-0" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "position-absolute top-0 end-0 me-n5" }
const _hoisted_14 = { class: "btn btn-icon btn-sm btn-active-color-primary pe-0 me-2" }
const _hoisted_15 = { class: "btn btn-icon btn-sm btn-active-color-primary ps-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_FeedsWidget3 = _resolveComponent("FeedsWidget3")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_avatar, {
              size: "80",
              fullname: _ctx.currentProveedor.nombreProveedor,
              color: "#005E8A"
            }, null, 8, ["fullname"]),
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.currentProveedor.nombreProveedor), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentProveedor.rutProveedor), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FeedsWidget3, {
          "widget-classes": "mb-5 mb-xl-8",
          currentTicket: _ctx.profileDetails
        }, null, 8, ["currentTicket"]),
        _createElementVNode("div", {
          class: _normalizeClass(["card", _ctx.widgetClasses])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Form, {
              id: "kt_account_profile_details_form",
              novalidate: "novalidate",
              onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveChanges1())),
              "validation-schema": _ctx.profileDetailsValidator,
              class: "position-relative mb-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Field, {
                  as: "textarea",
                  class: "form-control border-0 p-0 pe-10 resize-none min-h-25px",
                  "data-kt-autosize": "true",
                  rows: "1",
                  type: "text",
                  placeholder: "Ingrese su respuesta aquí...",
                  name: "respuesta",
                  modelValue: _ctx.profileDetails.respuesta,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileDetails.respuesta) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "respuesta" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-ban",
                      class: "p-button-rounded p-button-secondary",
                      type: "reset"
                    })
                  ]),
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-save",
                      class: "p-button-rounded p-button-primary",
                      type: "submit",
                      id: "kt_account_profile_details_submit",
                      ref: "submitButton1"
                    }, null, 512)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ])
        ], 2)
      ])
    ])
  ]))
}